module.exports = __webpack_public_path__ + "img/IMG_9908.bfef9cc9.jpg";